module.exports = {
      id: "logic-usage",
      viewBox: "0 0 19.765 19.765",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#logic",
      toString: function () {
        return this.url;
      }
    }